import Vue from "vue";
import {
  FormInputTypes,
  WorkflowStepType,
  FormTakerMode
} from "@/lib/utilities/enums";
import moment from "moment";

function initialState() {
  return {
    FormTaker: {
      Mode: FormTakerMode.StepInstanceForm,
      Type: null,
      StepInstanceId: null,
      Name: null,
      WorkflowTemplateId: null,
      StartableFormTemplateId: null,
      PlatformId: null,
      StepStatus: null,
      FormInstance: null,
      IsLoading: false,
      CallInProgress: false,
      FormError: null
    }
  };
}

function checkPadding(val) {
  if (val) {
    if (val > 9) return val;
    else return "0" + val;
  }
  return "00";
}

function generateFormRequestAnswers(controls, submit) {
  try {
    let hasError = false;
    let errorMessage = "";
    let formAnswers = [];

    if (controls && controls.length > 0) {
      for (let control of controls) {
        let inputType = FormInputTypes.find(function(itype) {
          return itype.Id == control.InputType;
        });

        if (!inputType || !inputType.Name) break;
        else if (inputType.Name == "ShortAnswer") {
          //InputType(s): 2

          if (submit && control.InputFormatType == 2) {
            if (!control.Value) {
              errorMessage = "Please enter password";
              hasError = true;
              break;
            } else if (control.Value != control.ConfirmValue) {
              errorMessage =
                "Passwords do not match. Please enter the same value for password and confirm password.";
              hasError = true;
              break;
            }
          } else if (submit && control.InputFormatType == 3) {
            let emailRegex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

            if (!control.Value || !emailRegex.test(control.Value)) {
              errorMessage =
                "Invalid email. Please enter a valid email address.";
              hasError = true;
              break;
            } else if (control.Value !== control.ConfirmValue) {
              errorMessage =
                "Email addresses do not match. Please enter the same value for email and confirm email.";
              hasError = true;
              break;
            }
          }
          formAnswers.push({
            FormControlId: control.Id,
            InputType: control.InputType,
            Value: control.Value
          });
        } else if (inputType.Name == "ShortName") {
          //InputType(s): 10
          formAnswers.push({
            FormControlId: control.Id,
            InputType: control.InputType,
            Name: {
              First: control.FirstName,
              Last: control.LastName
            }
          });
        } else if (inputType.Name == "FullName") {
          //InputType(s): 11
          formAnswers.push({
            FormControlId: control.Id,
            InputType: control.InputType,
            Name: {
              Title: control.Title,
              First: control.FirstName,
              Middle: control.MiddleName,
              Last: control.LastName,
              Suffix: control.Suffix
            }
          });
        } else if (inputType.Name == "Address") {
          //InputType(s): 12
          formAnswers.push({
            FormControlId: control.Id,
            InputType: control.InputType,
            Address: {
              AddressLine1: control.AddressLine1,
              AddressLine2: control.AddressLine2,
              Country:
                control.SelectedCountry && control.SelectedCountry.length > 0
                  ? control.SelectedCountry[0]
                  : "",
              StateProvince:
                control.SelectedState && control.SelectedState.length > 0
                  ? control.SelectedState[0]
                  : "",
              City: control.City,
              Zip: control.Zip
            }
          });
        } else if (inputType.Name == "Date") {
          //InputType(s): 6
          let offsetMinutes = new Date().getTimezoneOffset();
          let hours = Math.floor(offsetMinutes / 60);
          let minutes = offsetMinutes - hours * 60;
          formAnswers.push({
            FormControlId: control.Id,
            InputType: control.InputType,
            Value:
              moment(control.Date).format("YYYY-MM-DDT00:00:00") +
              "-" +
              checkPadding(hours) +
              ":" +
              checkPadding(minutes)
          });
        } else if (inputType.Name == "Time") {
          //InputType(s): 7
          formAnswers.push({
            FormControlId: control.Id,
            InputType: control.InputType,
            Value: control.Time
          });
        } else if (inputType.Name == "SingleSelectDropDown") {
          //InputType(s): 4
          formAnswers.push({
            FormControlId: control.Id,
            InputType: control.InputType,
            Value: control.Value,
            OtherValue:
              control.HasOther && control.OtherId == control.Value
                ? control.OtherValue
                : ""
          });
        } else if (inputType.Name == "SingleSelectRadio") {
          //InputType(s): 8
          formAnswers.push({
            FormControlId: control.Id,
            InputType: control.InputType,
            Value: control.Value,
            OtherValue:
              control.HasOther && control.OtherId == control.Value
                ? control.OtherValue
                : ""
          });
        } else if (inputType.Name == "MultiSelection") {
          //InputType(s): 5
          let answer = {
            FormControlId: control.Id,
            InputType: control.InputType,
            Values: [],
            OtherValue: null
          };

          //If there is Other option and is selected, copy its value into the OtherValue field
          if (control.HasOther && control.Value && control.Value.length > 0) {
            let indexOfOther = control.Value.indexOf(control.OtherId);
            if (indexOfOther >= 0) {
              answer.OtherValue = control.OtherValue;

              //If there is Other option and is selected, remove it from the list of ids sent to API
              // control.Value.splice(indexOfOther, 1);
            }
          }
          answer.Values = control.Value;
          formAnswers.push(answer);
        } else {
          //InputType(s): 0, 1, 3, 6, 7, 9
          formAnswers.push({
            FormControlId: control.Id,
            InputType: control.InputType,
            Value: control.Value
          });
        }
      }
    }

    if (hasError)
      return {
        FormAnswers: null,
        ErrorMessage: errorMessage
      };

    return {
      FormAnswers: formAnswers
    };
  } catch (err) {
    return null;
  }
}

function copyAnyExistingAnswers(form) {
  try {
    if (
      form &&
      form.FormTemplate &&
      form.FormTemplate.Controls &&
      form.FormTemplate.Controls.length > 0
    ) {
      for (let control of form.FormTemplate.Controls) {
        let inputType = FormInputTypes.find(function(itype) {
          return itype.Id == control.InputType;
        });

        if (!inputType || !inputType.Name) continue;

        control.InputTypeName = inputType.Name;

        let answer = null;

        if (
          form.FormAnswers &&
          form.FormAnswers.Answers &&
          form.FormAnswers.Answers.length > 0
        ) {
          for (let formAnswer of form.FormAnswers.Answers) {
            if (answer == null && formAnswer.FormControlId == control.Id) {
              answer = formAnswer;
            }
          }
        }

        if (inputType.Name == "ShortAnswer") {
          //InputType(s): 2
          control.Value = null;
          if (control.InputFormatType == 2 || control.InputFormatType == 3) {
            control.ConfirmValue = null;
          }

          if (answer) {
            if (answer.Value) control.Value = answer.Value;
            if (control.InputFormatType == 2 || control.InputFormatType == 3)
              control.ConfirmValue = answer.Value;
          }
        } else if (inputType.Name == "ShortName") {
          //InputType(s): 10
          control.FirstName = null;
          control.LastName = null;

          if (answer && answer.Name) {
            //answer.Value?
            control.FirstName = answer.Name.First;
            control.LastName = answer.Name.Last;
          }
        } else if (inputType.Name == "FullName") {
          //InputType(s): 11
          control.Title = null;
          control.FirstName = null;
          control.MiddleName = null;
          control.LastName = null;
          control.Suffix = null;

          if (answer && answer.Name) {
            //answer.Value?
            control.Title = answer.Name.Title;
            control.FirstName = answer.Name.First;
            control.MiddleName = answer.Name.Middle;
            control.LastName = answer.Name.Last;
            control.Suffix = answer.Name.Suffix;
          }
        } else if (inputType.Name == "Address") {
          //InputType(s): 12
          control.AddressLine1 = null;
          control.AddressLine2 = null;
          control.City = null;
          control.Zip = 0;

          //Add country and state fields
          control = insertCountryAndStateFields(control);

          if (answer && answer.Address) {
            //answer.Value?
            control.AddressLine1 = answer.Address.AddressLine1;
            control.AddressLine2 = answer.Address.AddressLine2;
            control.City = answer.Address.City;
            control.Zip = answer.Address.Zip;
            control.SelectedCountry.push(answer.Address.Country);
            control.SelectedState.push(answer.Address.StateProvince);
          }
        } else if (inputType.Name == "Date") {
          //InputType(s): 6
          control.Date = moment().format("YYYY-MM-DD");

          if (answer && answer.Value) {
            let date = moment(answer.Value);
            if (date && date.isValid())
              control.Date = date.format("YYYY-MM-DD");
          }
        } else if (inputType.Name == "Time") {
          //InputType(s): 7
          control.Time = moment().format("hh:mm A");

          if (answer) {
            if (answer.Value) {
              control.Time = answer.Value;
              // let date = moment(answer.Value);
              // if (date && date.isValid()) control.Time = date.format("hh:mm A");
            }
          }
        } else if (inputType.Name == "SingleSelectDropDown") {
          //InputType(s): 4
          control.Value = null;

          if (control.HasOther) {
            control.OtherValue = null;

            control.OtherId = 1;
            if (control.ControlOptions && control.ControlOptions.length > 0)
              control.OtherId += control.ControlOptions.length;
            else control.ControlOptions = new Array();

            control.OtherId += "";
            control.ControlOptions.push({
              Id: control.OtherId,
              OptionLabel: "Other"
            });
          }

          if (answer) {
            if (answer.Value) control.Value = answer.Value;
            if (answer.OtherValue) {
              control.OtherValue = answer.OtherValue;
            }
          }
        } else if (inputType.Name == "SingleSelectRadio") {
          //InputType(s): 8
          control.Value = null;

          if (control.HasOther) {
            control.OtherValue = null;

            control.OtherId = 1;
            if (control.ControlOptions && control.ControlOptions.length > 0)
              control.OtherId += control.ControlOptions.length;
            else control.ControlOptions = new Array();

            control.OtherId += "";
            control.ControlOptions.push({
              Id: control.OtherId,
              OptionLabel: "Other"
            });
          }

          if (answer) {
            if (answer.Value) control.Value = answer.Value;
            if (answer.OtherValue) {
              control.OtherValue = answer.OtherValue;
            }
          }
        } else if (inputType.Name == "MultiSelection") {
          //InputType(s): 5
          control.Value = [];

          if (control.HasOther) {
            control.OtherValue = null;

            control.OtherId = 1;
            if (control.ControlOptions && control.ControlOptions.length > 0)
              control.OtherId += control.ControlOptions.length;
            else control.ControlOptions = new Array();

            control.OtherId += "";
            control.ControlOptions.push({
              Id: control.OtherId,
              OptionLabel: "Other"
            });
          }

          if (answer) {
            if (answer.ValueList) control.Value = answer.ValueList;
            if (answer.OtherValue) {
              control.OtherValue = answer.OtherValue;
            }
          }
        } else {
          //InputType(s): 0, 1, 3, 6, 7, 9
          control.Value = null;

          if (answer && answer.Value) {
            control.Value = answer.Value;
          }
        }
      }
    }
  } catch (err) {
    // Nothing to do
  }

  return form;
}

function insertCountryAndStateFields(control) {
  try {
    control.Countries = [
      {
        Id: "US",
        Country: "United States"
      },
      {
        Id: "CA",
        Country: "Canada"
      }
    ];
    control.States = [
      {
        Id: "AL",
        State: "Alabama",
        CountryId: "US"
      },
      {
        Id: "AK",
        State: "Alaska",
        CountryId: "US"
      },
      {
        Id: "AZ",
        State: "Arizona",
        CountryId: "US"
      },
      {
        Id: "AR",
        State: "Arkansas",
        CountryId: "US"
      },
      {
        Id: "CA",
        State: "California",
        CountryId: "US"
      },
      {
        Id: "CO",
        State: "Colorado",
        CountryId: "US"
      },
      {
        Id: "CT",
        State: "Connecticut",
        CountryId: "US"
      },
      {
        Id: "DE",
        State: "Delaware",
        CountryId: "US"
      },
      {
        Id: "DC",
        State: "Dist. of Columbia",
        CountryId: "US"
      },
      {
        Id: "FL",
        State: "Florida",
        CountryId: "US"
      },
      {
        Id: "GA",
        State: "Georgia",
        CountryId: "US"
      },
      {
        Id: "HI",
        State: "Hawaii",
        CountryId: "US"
      },
      {
        Id: "Id",
        State: "Idaho",
        CountryId: "US"
      },
      {
        Id: "IL",
        State: "Illinois",
        CountryId: "US"
      },
      {
        Id: "IN",
        State: "Indiana",
        CountryId: "US"
      },
      {
        Id: "IA",
        State: "Iowa",
        CountryId: "US"
      },
      {
        Id: "KS",
        State: "Kansas",
        CountryId: "US"
      },
      {
        Id: "KY",
        State: "Kentucky",
        CountryId: "US"
      },
      {
        Id: "LA",
        State: "Louisiana",
        CountryId: "US"
      },
      {
        Id: "ME",
        State: "Maine",
        CountryId: "US"
      },
      {
        Id: "MD",
        State: "Maryland",
        CountryId: "US"
      },
      {
        Id: "MA",
        State: "Massachusetts",
        CountryId: "US"
      },
      {
        Id: "MI",
        State: "Michigan",
        CountryId: "US"
      },
      {
        Id: "MN",
        State: "Minnesota",
        CountryId: "US"
      },
      {
        Id: "MS",
        State: "Mississippi",
        CountryId: "US"
      },
      {
        Id: "MO",
        State: "Missouri",
        CountryId: "US"
      },
      {
        Id: "MT",
        State: "Montana",
        CountryId: "US"
      },
      {
        Id: "NE",
        State: "Nebraska",
        CountryId: "US"
      },
      {
        Id: "NV",
        State: "Nevada",
        CountryId: "US"
      },
      {
        Id: "NH",
        State: "New Hampshire",
        CountryId: "US"
      },
      {
        Id: "NJ",
        State: "New Jersey",
        CountryId: "US"
      },
      {
        Id: "NM",
        State: "New Mexico",
        CountryId: "US"
      },
      {
        Id: "NY",
        State: "New York",
        CountryId: "US"
      },
      {
        Id: "NC",
        State: "North Carolina",
        CountryId: "US"
      },
      {
        Id: "ND",
        State: "North Dakota",
        CountryId: "US"
      },
      {
        Id: "OH",
        State: "Ohio",
        CountryId: "US"
      },
      {
        Id: "OK",
        State: "Oklahoma",
        CountryId: "US"
      },
      {
        Id: "OR",
        State: "Oregon",
        CountryId: "US"
      },
      {
        Id: "PA",
        State: "Pennsylvania",
        CountryId: "US"
      },
      {
        Id: "PR",
        State: "Puerto Rico",
        CountryId: "US"
      },
      {
        Id: "RI",
        State: "Rhode Island",
        CountryId: "US"
      },
      {
        Id: "SC",
        State: "South Carolina",
        CountryId: "US"
      },
      {
        Id: "SD",
        State: "South Dakota",
        CountryId: "US"
      },
      {
        Id: "TN",
        State: "Tennessee",
        CountryId: "US"
      },
      {
        Id: "TX",
        State: "Texas",
        CountryId: "US"
      },
      {
        Id: "UT",
        State: "Utah",
        CountryId: "US"
      },
      {
        Id: "VT",
        State: "Vermont",
        CountryId: "US"
      },
      {
        Id: "VA",
        State: "Virginia",
        CountryId: "US"
      },
      {
        Id: "WA",
        State: "Washington",
        CountryId: "US"
      },
      {
        Id: "WV",
        State: "West Virginia",
        CountryId: "US"
      },
      {
        Id: "WI",
        State: "Wisconsin",
        CountryId: "US"
      },
      {
        Id: "WY",
        State: "Wyoming",
        CountryId: "US"
      },
      {
        Id: "AB",
        State: "Alberta",
        CountryId: "CA"
      },
      {
        Id: "BC",
        State: "British Columbia",
        CountryId: "CA"
      },
      {
        Id: "MB",
        State: "Manitoba",
        CountryId: "CA"
      },
      {
        Id: "NB",
        State: "New Brunswick",
        CountryId: "CA"
      },
      {
        Id: "NL",
        State: "Newfoundland and Labrador",
        CountryId: "CA"
      },
      {
        Id: "NT",
        State: "Northwest Territories",
        CountryId: "CA"
      },
      {
        Id: "NS",
        State: "Nova Scotia",
        CountryId: "CA"
      },
      {
        Id: "NU",
        State: "Nunavut",
        CountryId: "CA"
      },
      {
        Id: "ON",
        State: "Ontario",
        CountryId: "CA"
      },
      {
        Id: "PE",
        State: "Prince Edward Island",
        CountryId: "CA"
      },
      {
        Id: "QC",
        State: "Quebec",
        CountryId: "CA"
      },
      {
        Id: "SK",
        State: "Saskatchewan",
        CountryId: "CA"
      },
      {
        Id: "YT",
        State: "Yukon",
        CountryId: "CA"
      }
    ];

    control.SelectedCountry = [];
    control.SelectedState = [];
    control.FilteredStates = control.States.filter(function(st) {
      return (
        control.SelectedCountry &&
        control.SelectedCountry.length > 0 &&
        st.CountryId == control.SelectedCountry[0]
      );
    });
  } catch (err) {
    // Nothing to do
  }

  return control;
}

const state = initialState();

const getters = {
  FormTaker(state) {
    return state.FormTaker;
  },
  FormInstance(state) {
    return state.FormTaker.FormInstance;
  }
};

const actions = {
  async loadUnfinishedForm(context, val) {
    await context.commit("updateFormTaker", val);
    context.dispatch("getFormForStep");
  },
  async loadStartProcessForm(context, val) {
    //Clear right nav section
    context.dispatch("closeFormTaker");

    // Wait for openFormTaker action to finish...
    await context.commit("updateFormTaker", val);
    context.dispatch("getFormForStep");
  },
  closeFormTaker(context) {
    context.commit("closeFormTaker");
  },
  submitFormResponse(context, val) {
    return new Promise((resolve, reject) => {
      context.commit("setFormErrorMessage", null);

      //If a previous request is in progress, return
      if (state.FormTaker.CallInProgress) resolve(false);
      else if (
        !state.FormTaker.FormInstance ||
        !state.FormTaker.FormInstance.FormTemplate ||
        !state.FormTaker.FormInstance.FormTemplate.Id ||
        (state.FormTaker.Mode == FormTakerMode.StepInstanceForm &&
          !state.FormTaker.StepInstanceId)
      ) {
        context.commit(
          "setFormErrorMessage",
          "Invalid template. Please complete a template and submit."
        );
        resolve(false);
      } else {
        const controls = val.Controls;
        const submit = val.Submit;

        //Generate form request
        let response = generateFormRequestAnswers(controls, submit);

        if (response.ErrorMessage) {
          context.commit("setFormErrorMessage", response.ErrorMessage);
          resolve(false);
        } else if (!response.FormAnswers || response.FormAnswers.length == 0)
          resolve(false);
        else {
          context.commit("setFormTakerCallInProgress", true);

          if (state.FormTaker.Mode == FormTakerMode.StartProcessForm) {
            context
              .dispatch("startNewProcess", {
                TemplateId: state.FormTaker.WorkflowTemplateId,
                PlatformId: state.FormTaker.PlatformId,
                Form: {
                  Answers: response.FormAnswers,
                  AccountId: context.getters.User.AccountID,
                  PlatformId: state.FormTaker.PlatformId,
                  FormTemplateId: state.FormTaker.StartableFormTemplateId,
                  FuzeCastUserId: context.getters.User.UserId
                }
              })
              .then(resp => {
                context.commit("setFormTakerCallInProgress", false);
                // context.commit("closeFormTaker");
                resolve(true);
              })
              .catch(resp => {
                context.commit("setFormTakerCallInProgress", false);
                context.commit(
                  "setFormErrorMessage",
                  "There was an error starting the selected process. Please try again later."
                );
                resolve(false);
              });
          } else {
            let formRequest = {
              FormTemplateId: state.FormTaker.FormInstance.FormTemplate.Id,
              WorkflowTemplateId: state.FormTaker.WorkflowTemplateId,
              FuzeCastUserId: context.getters.User.Id,
              StepId: state.FormTaker.StepInstanceId,
              Answers: response.FormAnswers
            };

            let requestUrl = "/pando/forms/save";
            if (submit) {
              requestUrl = "/pando/forms/submit";
            }

            Vue.http
              .post(requestUrl, formRequest)
              .then(function(resp) {
                context.dispatch("handleFormSubmissionResponse", {
                  Response: resp,
                  Success: true
                });
                resolve(true);
              })
              .catch(function(resp) {
                context.dispatch("handleFormSubmissionResponse", {
                  Response: resp,
                  Success: false
                });
                resolve(false);
              });
          }
        }
      }
    });
  },
  async getFormForStep(context) {
    if (
      !state.FormTaker.IsLoading &&
      (state.FormTaker.StepInstanceId ||
        state.FormTaker.StartableFormTemplateId)
    ) {
      context.commit("formIsLoading", true);

      let requestUrl = `/pando/forms/step/${state.FormTaker.StepInstanceId}`;
      if (
        !state.FormTaker.StepInstanceId &&
        state.FormTaker.StartableFormTemplateId
      )
        requestUrl = `/pando/formtemplate/getstartform/${state.FormTaker.StartableFormTemplateId}`;

      Vue.http
        .get(requestUrl)
        .then(function(resp) {
          context.dispatch("gotFormForStep", {
            Response: resp.data,
            Success: true
          });
        })
        .catch(function(resp) {
          context.dispatch("gotFormForStep", {
            Response: resp,
            Success: false
          });
        });
    }
  },
  async gotFormForStep(context, val) {
    let response = val.Response;
    let success = val.Success;

    context.commit("formIsLoading", false);

    if (response && success) {
      if (state.FormTaker.StartableFormTemplateId) {
        response = {
          Type: WorkflowStepType.Form,
          WorkflowTemplateId: state.FormTaker.WorkflowTemplateId,
          Form: response
        };
      }

      if (
        response.Type == WorkflowStepType.Form ||
        response.Type == WorkflowStepType.Survey ||
        response.Type == WorkflowStepType.Integration
      ) {
        switch (response.Type) {
          case WorkflowStepType.Survey:
            context.commit("setFormTakerType", "survey");
            break;
          case WorkflowStepType.Form:
            context.commit("setFormTakerType", "form");
            break;
          case WorkflowStepType.Integration:
            context.commit("setFormTakerType", "integration");
            break;
        }

        context.commit(
          "setFormTakerWorkflowTemplateId",
          response.WorkflowTemplateId
        );

        let form = copyAnyExistingAnswers(response.Form);

        if (form && form.FormAnswers && form.FormAnswers.IsSubmitted) {
          if (
            form.FormAnswers.UserId &&
            context.getters.accountUsers &&
            context.getters.accountUsers.length > 0
          ) {
            form.FormAnswers.User = context.getters.accountUsers.find(function(
              user
            ) {
              return user.UserId == form.FormAnswers.UserId;
            });
          }
        }

        context.commit("setFormTakerInstance", form);
      }
    } else {
      context.dispatch("handleFailResponse", {
        Response: response,
        CustomMessage: null
      });
    }
  },
  loadCompletedForm(context, val) {
    context.commit("updateFormTaker", val);

    const formInstanceId = val.FormInstanceId;

    if (formInstanceId && !state.FormTaker.IsLoading) {
      context.commit("formIsLoading", true);

      Vue.http
        .get("/pando/forms/" + formInstanceId + "/view")
        .then(function(resp) {
          context.dispatch("gotFormForStep", {
            Response: resp.data,
            Success: true
          });
        })
        .catch(function(resp) {
          context.dispatch("gotFormForStep", {
            Response: resp,
            Success: false
          });
        });
    }
  },
  handleFormSubmissionResponse(context, data) {
    context.commit("setFormTakerCallInProgress", false);

    const success = data.Success;

    if (success) {
      const response = data.Response.data ? data.Response.data.Data : null;

      if (
        response &&
        response.GroupId &&
        (response.Outcome == 0 || response.Outcome == 100)
      ) {
        //TODO: Add support for toast messages
        // toastr.success(type == "form" ? 'Your form has been successfully submitted' : 'Your response has been successfully saved.', 'Success');
        if (response.Outcome !== 100)
          context.dispatch("addGroupToList", {
            OldGroup: response,
            OpenDetail: true
          });

        context.dispatch("closeFormTaker");
      } else {
        console.log(data.Response);
        const errMsg =
          state.FormTaker.Type == "form"
            ? "There was an error submitting your form. Please try again later."
            : "There was an error saving your response. Please try again later.";
        context.commit("setFormErrorMessage", errMsg);
      }
    } else {
      console.log(data.Response);
      const errMsg =
        state.FormTaker.Type == "form"
          ? "There was an error submitting your form. Please try again later."
          : "There was an error saving your response. Please try again later.";
      context.commit("setFormErrorMessage", errMsg);

      context.dispatch("handleFailResponse", {
        Response: data.Response,
        CustomMessage: null
      });
    }
  }
};

const mutations = {
  updateFormTaker(state, val) {
    state.FormTaker.Mode = val.Mode || FormTakerMode.StepInstanceForm;
    state.FormTaker.StepStatus = val.StepStatus;
    state.FormTaker.StepInstanceId = val.StepInstanceId;
    state.FormTaker.Name = val.Name;
    state.FormTaker.WorkflowTemplateId = val.WorkflowTemplateId;
    state.FormTaker.StartableFormTemplateId = val.StartableFormTemplateId;
    state.FormTaker.PlatformId = val.PlatformId;
  },
  closeFormTaker(state) {
    //Existing FormTaker property loses reactivity when you assign directly to state
    let originalState = initialState();
    state.FormTaker = originalState.FormTaker;
  },
  formIsLoading(state, val) {
    state.FormTaker.IsLoading = val;
  },
  updateFormTakerStep(state, val) {
    state.FormTaker.StepStatus = val.StepStatus;
    state.FormTaker.StepInstanceId = val.StepInstanceId;
    state.FormTaker.Name = val.Name;
  },
  setFormTakerType(state, val) {
    state.FormTaker.Type = val;
  },
  setFormTakerWorkflowTemplateId(state, val) {
    state.FormTaker.WorkflowTemplateId = val;
  },
  setFormTakerInstance(state, val) {
    state.FormTaker.FormInstance = val;
  },
  setFormErrorMessage(state, val) {
    state.FormTaker.FormError = val;
  },
  setFormTakerCallInProgress(state, val) {
    state.FormTaker.CallInProgress = val;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/customerdashboard/FormTaker.js